
const MAX_EXPORT_ROWS = 500;

export interface FetchAllPagesForExportParams<TRow> {
  fetchPage: (_page: number, _pageSize: number) => Promise<{ rows: TRow[]; total: number }>;
  pageSize: number;
}

export async function fetchAllPagesForExport<TRow>(
  params: FetchAllPagesForExportParams<TRow>,
): Promise<TRow[]> {
  const { fetchPage, pageSize } = params;
  const firstPage = await fetchPage(1, pageSize);
  const allRows = [...firstPage.rows];
  const targetCount = Math.min(firstPage.total, MAX_EXPORT_ROWS);

  let page = 2;
  while (allRows.length < targetCount && firstPage.rows.length > 0) {
    // eslint-disable-next-line no-await-in-loop -- pages must be fetched in order to build one contiguous row list.
    const next = await fetchPage(page, pageSize);
    if (next.rows.length === 0) {
      break;
    }
    allRows.push(...next.rows);
    page += 1;
  }

  return allRows.slice(0, MAX_EXPORT_ROWS);
}
